import { TransferListCategoryOption } from 'src/components/TransferList';
import usePeriodView from 'src/hooks/usePeriodView';
import Workflow from './Workflow';

export const approvalWorkflowOptions: TransferListCategoryOption[] = [
  { value: 0, label: 'Show All', filters: [] },
  {
    value: 1,
    label: 'Show Active',
    filters: [{ operator: 'neq', field: 'isDeleted', value: true }],
  },
  {
    value: 2,
    label: 'Show Disabled',
    filters: [{ operator: 'eq', field: 'isDeleted', value: true }],
  },
];

const ApprovalWorkflow = () => {
  const {
    invoiceAssignedUsers,
    invoiceUnassignedUsers,
    setInvoiceAssignedUsers,
    setInvoiceUnassignedUsers,
    poAssignedUsers,
    poUnassignedUsers,
    setPoUnassignedUsers,
    setPoAssignedUsers,
    poAttributesOption,
    setPoAttributesOption,
    invoiceAttributesOption,
    setInvoiceAttributesOption,
  } = usePeriodView();

  return (
    <div className="bg-[#EEEEEE] divide-x-2 divide-gray-400 flex mt-4">
      <Workflow
        title="PO Workflows"
        leftList={poUnassignedUsers}
        rightList={poAssignedUsers}
        setLeftList={setPoUnassignedUsers}
        setRightList={setPoAssignedUsers}
        option={poAttributesOption}
        setOption={setPoAttributesOption}
        isPoWorkFlow={true}
      />
      <Workflow
        title="Invoice Workflows"
        leftList={invoiceUnassignedUsers}
        rightList={invoiceAssignedUsers}
        setLeftList={setInvoiceUnassignedUsers}
        setRightList={setInvoiceAssignedUsers}
        option={invoiceAttributesOption}
        setOption={setInvoiceAttributesOption}
        isPoWorkFlow={false}
      />
    </div>
  );
};

export default ApprovalWorkflow;
